// removed by extract-text-webpack-plugin
module.exports = {"bullet":"G92fc92","list":"Gdef850","tick":"G960eba Gb69063 G149cfa Gc7b2d5"};